(function(){
  function initRevs(){
    var track=document.getElementById('bp-revs');
    if(!track) return;
    var prev=document.getElementById('bp-rev-prev');
    var next=document.getElementById('bp-rev-next');
    function step(){
      var card=track.querySelector('.bp-rev');
      if(!card) return 300;
      var gap=parseInt(getComputedStyle(track).columnGap||18,10)||18;
      return card.getBoundingClientRect().width+gap;
    }
    function update(){
      var max=track.scrollWidth-track.clientWidth-2;
      if(prev) prev.disabled=track.scrollLeft<=2;
      if(next) next.disabled=track.scrollLeft>=max;
    }
    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',function(){window.requestAnimationFrame(update);});
    window.addEventListener('resize',update);
    update();
  }

  function initVideoLoop(){
    var v=document.querySelector('#bp-root .bp-ps video');
    if(!v) return;

    function restart(){
      try{ v.currentTime=0; }catch(e){}
      var p=v.play();
      if(p && p.catch) p.catch(function(){});
    }

    // Valgfrit klippepunkt: springer tilbage før videoens slutning
    var cut=parseFloat(v.getAttribute('data-loop-end')||'');
    if(cut && !isNaN(cut) && cut>0){
      v.removeAttribute('loop');
      v.addEventListener('timeupdate',function(){
        if(v.currentTime>=cut) restart();
      });
    }

    // Sikkerhedsnet: nogle browsere efterlader et ophold ved native loop
    v.addEventListener('ended',restart);

    // Start igen hvis fanen har været i baggrunden
    document.addEventListener('visibilitychange',function(){
      if(!document.hidden && v.paused){
        var p=v.play();
        if(p && p.catch) p.catch(function(){});
      }
    });
  }

  function init(){ initRevs(); initVideoLoop(); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();